<template>
    <div id="app">
        <v-slide-x-transition>
            <v-card v-if="showHelpSection" flat id="main-container">
                <div class="help-header">
                    <div id="help-header-button">
                        <v-btn @click="goBack" icon>
                            <v-icon>
                                fas fa-arrow-circle-left
                            </v-icon>
                        </v-btn>
                    </div>
                    <div id="help-header-title">
                        Quick Copy
                    </div>
                </div>

                <div style="width: 100%; height: 90%; padding-top: 10%; padding-left: 10%; padding-right: 10%">
                    <v-card flat style="width: 50%; height: 40%; float: left;  display: flex; justify-content: center; align-items: center">
                        <v-card-text style="text-align: left">
                            You are able to copy and paste reference numbers and phone numbers with ease. <br>
                            The numbers which are quick copy compatible will display a blue icon beside it when you move the cursor over it.
                        </v-card-text>
                    </v-card>
                    <v-card flat style="width: 50%; height: 40%; float: left;  display: flex; justify-content: center; align-items: center">
                        <v-badge
                                color="blue"
                                right
                                overlap
                        >
                            <template v-slot:badge>
                                <span  style="display: flex; justify-content: center; align-items: center;"><v-icon style="font-size: 10px" color="white">fas fa-clone</v-icon></span>
                            </template>
                            <div>
                                O6phPW72r9tF
                            </div>
                        </v-badge>
                    </v-card>
                    <v-card flat style="width: 50%; height: 40%; float: left;  display: flex; justify-content: center; align-items: center">
                        <v-badge
                                color="green"
                                right
                                overlap
                        >
                            <template v-slot:badge>
                                <span style="display: flex; justify-content: center; align-items: center;"><v-icon style="font-size: 10px" color="white">fas fa-check</v-icon></span>
                            </template>
                            <div>
                                O6phPW72r9tF
                            </div>
                        </v-badge>
                    </v-card>


                    <v-card flat style="width: 50%; height: 40%; float: left;  display: flex; justify-content: center; align-items: center">
                        <v-card-text style="text-align: left;">

                            When a quick copy compatible number has been copied the blue icon will be replaced with a green tick icon

                        </v-card-text>

                    </v-card>





                </div>

            </v-card>
        </v-slide-x-transition>
    </div>
</template>

<script>
    import Vue from 'vue'
    import Vuetify from 'vuetify'
    import 'vuetify/dist/vuetify.min.css'
    import VueApexCharts from 'vue-apexcharts'

    Vue.use(Vuetify)
    Vue.use(VueApexCharts)
    export default {

        components: {
            apexcharts: VueApexCharts
        },

        data () {
            return {
                showHelpSection: false,
            }
        },
        watch: {},
        created: function () {
            document.title = 'Chattube - Help'
            setTimeout(() => this.showHelpSection = true, 500)
        },
        computed: {},
        methods: {
            goBack(){
                this.$emit('pageCloseTrigger',true)
            }
        }
    }
</script>

<style scoped>
    html, body {
        height: 100%;
        margin: 0;
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        text-align: center;
        color: black;
        background-color: white;

        width: 100%;
        height: 100%;
        background-size: cover;
        overflow: hidden;
        padding: 1%;
    }
    .main-selection-div {
        width: 33.3%; height: 100%; float: left;
        display: flex; justify-content: center; align-items: center;
    }
    .selection-icon {
        width: 100%; height: 60%; display: flex; justify-content: center; align-items: center
    }
    .selection-text {
        color: white;width: 100%; height: 40%; display: flex; justify-content: center; align-items: center; font-size: 5vh; font-weight: bold
    }
    .card-area {
        height: 80%;
        width: 90%;
    }
    #main-container {
        width: 100%; height: 100%;

    }
    .help-header {
        width: 100%; height: 10%; font-size: 5vh; font-weight: bold; color: #4c4c4c
    }
    #help-header-button {
        width: 10%;height: 100%; float: left; display: flex; justify-content: center; align-items: center
    }
    #help-header-title {
        width: 90%;height: 100%; float: left; padding-right: 10%; display: flex; justify-content: center; align-items: center
    }
</style>